__turbopack_context__.v({
  "buttonContainer": "style-module-scss-module__D1swOq__buttonContainer",
  "error": "style-module-scss-module__D1swOq__error",
  "field": "style-module-scss-module__D1swOq__field",
  "fieldsWrap": "style-module-scss-module__D1swOq__fieldsWrap",
  "footer": "style-module-scss-module__D1swOq__footer",
  "footerText": "style-module-scss-module__D1swOq__footerText",
  "footerYear": "style-module-scss-module__D1swOq__footerYear",
  "hidden": "style-module-scss-module__D1swOq__hidden",
  "link": "style-module-scss-module__D1swOq__link",
  "submitButton": "style-module-scss-module__D1swOq__submitButton",
  "text": "style-module-scss-module__D1swOq__text",
  "title": "style-module-scss-module__D1swOq__title",
});
